'use strict';

var FlightLegAggregationFactory = function FlightLegAggregationFactory(FlightThematicDataAggregationFactory) {
  function FlightLegAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-leg');
    this.aggregationProperty = 'leg';
  }
  FlightLegAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightLegAggregation.constructor = FlightLegAggregation;
  return FlightLegAggregation;
};
FlightLegAggregationFactory.$inject = ['FlightThematicDataAggregationFactory'];
module.exports = FlightLegAggregationFactory;